const find = require("lodash/collection/find");
const { formatText } = require("core/i18n").i18n;

function idNumberOptions() {
    return [
        { label: formatText("documentTypes-idCard"), value: "N" },
        { label: formatText("documentTypes-passport"), value: "P" },
        { label: formatText("documentTypes-residenceCard"), value: "C" },
        { label: formatText("documentTypes-birthDate"), value: "FECHA_NACIMIENTO" },
        { label: formatText("documentTypes-unspecified"), value: "I" },
        { label: formatText("documentTypes-taxCode"), value: "S" }
    ];
}

function documentTypesOptions() {
    return {
        ES: [
            { label: formatText("documentTypes-idCard"), value: "N" },
            { label: formatText("documentTypes-passport"), value: "P" },
            { label: formatText("documentTypes-residenceCard"), value: "C" },
            { label: formatText("documentTypes-birthDate"), value: "FECHA_NACIMIENTO" },
            { label: formatText("documentTypes-unspecified"), value: "I" },
            { label: formatText("documentTypes-taxCode"), value: "S" }
        ],
        PT: [
            { label: formatText("documentTypes-idCardPT"), value: "CC" },
            { label: formatText("documentTypes-passportPT"), value: "PP" }
        ],
        NL: [
            { label: formatText("documentTypes-idCardNL"), value: "DN" },
            { label: formatText("documentTypes-passportNL"), value: "PN" }
        ],
        DE: [
            { label: formatText("documentTypes-idCardDE"), value: "DA" },
            { label: formatText("documentTypes-passportDE"), value: "PA" }
        ]
    };
}

function getLabel(typeDoc, country) {
    const documentTypesOptionsConst = documentTypesOptions();
    const idNumberOptionsConst = idNumberOptions();

    const documentsList = country
        ? documentTypesOptionsConst[country]
        : idNumberOptionsConst;
    const TDocument = find(documentsList, doc => doc.value === typeDoc);
    if (!TDocument) {
        return { label: formatText("documentTypes-notFound"), value: "NOT_FOUND" };
    }
    return TDocument;
}

function getDocumentLabelByCountry(documentType, country) {
    const documentTypesOptionsConst = documentTypesOptions();

    const documentLabel = find(
        documentTypesOptionsConst[country],
        doc => doc.value === documentType
    );
    if (!documentLabel) {
        return { label: formatText("documentTypes-notFound"), value: "NOT_FOUND" };
    }
    return documentLabel;
}

function getArrayDocuments() {
     return idNumberOptions();
}

module.exports = {
    getLabel,
    getArrayDocuments,
    getDocumentLabelByCountry
};
